export const formatList = [
  { format: 1, name: '版式一', },
  { format: 2, name: '版式二', },
];
